import { COLORS, createComponentWrapperWithRef, styled, THEME_CONST, uiTokens } from '../../../theme'
import { MsdkStyledComponent } from '../../../utils'
import { Card } from '../../Card'

/** @visibleName ViewLayout */
export const BodyWrapper: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 24px;
  overflow: auto;
`

export const MainContent: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`

export const HeaderWrapper: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  flex-flow: nowrap;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

type TWProps = { children: React.ReactNode }

const MuiTableWrapper: MsdkStyledComponent<TWProps> = styled('div')`
  width: 100%;
  display: flex;
  flex: 1;
  overflow: auto;
`

const NovaTableWrapper: MsdkStyledComponent<TWProps> = styled('div')`
  width: 100%;
  display: flex;
  flex: 1;
  overflow: auto;

  border-radius: ${uiTokens.radius.large}px;
  border: 1px solid ${uiTokens.uiStroke.neutral};
`

export const TableWrapper = createComponentWrapperWithRef(
  {
    mui: MuiTableWrapper,
    nova: NovaTableWrapper,
  },
  'TableWrapper',
)

type ETWProps = TWProps & { hideHeader: boolean; hidePaginator: boolean }
export const MuiEmbeddedTableWrapper: MsdkStyledComponent<ETWProps> = styled('div')<ETWProps>`
  margin: ${(props) => (props.hideHeader ? '16px' : '0px')} ${THEME_CONST.defaultPadding}px
    ${(props) => (props.hidePaginator ? '16px' : '0px')} ${THEME_CONST.defaultPadding}px;
`
export const NovaEmbeddedTableWrapper: MsdkStyledComponent<ETWProps> = styled('div')<ETWProps>`
  margin: 0;
`
export const EmbeddedTableWrapper = createComponentWrapperWithRef(
  {
    mui: MuiEmbeddedTableWrapper,
    nova: NovaEmbeddedTableWrapper,
  },
  'EmbeddedTableWrapper',
)

export const CardTable: MsdkStyledComponent<any> = styled(Card)`
  background-color: ${COLORS.components.tab.content.background};
  overflow: auto;
  box-shadow: unset;
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 0;
`

export const ActionsContainer: MsdkStyledComponent<any> = styled('div')`
  gap: 8px;
  display: flex;
  align-items: center;
`

type TabsContainerProps = {
  children: React.ReactNode
  className?: string
  $withPadding?: boolean
  orientation?: 'horizontal' | 'vertical'
}

const BaseTabsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== '$withPadding' && prop !== 'orientation',
})<TabsContainerProps>`
  display: flex;
  flex: 1;
  flex-direction: ${(props) => (props.orientation === 'vertical' ? 'row' : 'column')};
  overflow: hidden;
  .tab-content--active {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
  }
`

const MuiTabsContainer: MsdkStyledComponent<TabsContainerProps> = styled(BaseTabsContainer)`
  .tab-content--active {
    ${(props) =>
      props.$withPadding
        ? `padding: ${THEME_CONST.defaultPadding}px 0 ${THEME_CONST.defaultPadding}px ${THEME_CONST.defaultPadding}px;`
        : ''};
  }
`

const NovaTabsContainer: MsdkStyledComponent<TabsContainerProps> = styled(BaseTabsContainer)`
  .tab-content--active {
    ${(props) =>
      props.$withPadding
        ? `padding: ${uiTokens.spacing.padding.large}px 0 ${uiTokens.spacing.padding.large}px ${uiTokens.spacing.padding.large}px;`
        : ''};
  }
`

export const TabsContainer = createComponentWrapperWithRef(
  {
    mui: MuiTabsContainer,
    nova: NovaTabsContainer,
  },
  'TabsContainer',
)
